import { Provider } from "react-redux";
import "./App.css";
import AppRouter from "./routes/AppRouter";
import store, { persistor } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import { createTheme, ThemeProvider } from "@mui/material";
import TourGuide from "./Components/TourGuide";
import { useState } from "react";
import { GoogleOAuthProvider } from "@react-oauth/google";

function App() {
  const defaultTheme = createTheme({});
  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_CLIENT_ID}>
      <ThemeProvider theme={defaultTheme}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <AppRouter />
          </PersistGate>
        </Provider>
      </ThemeProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
